import { Icons } from "utils/iconPath";

export interface TabDataType {
  key: string;
  label: string;
  link: string;
  icon: string;
}

export const TABS_DATA: TabDataType[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    link: "/dashboard",
    icon: Icons.SIDE_BAR_DASHBOARD,
  },
  {
    key: "calendar",
    label: "Calendar",
    link: "/calendar",
    icon: Icons.SIDE_BAR_CALENDAR,
  },
  {
    key: "bookings",
    label: "Bookings",
    link: "/bookings",
    icon: Icons.SIDE_BAR_BOOKINGS,
  },
  // {
  //   key: "customers",
  //   label: "customers",
  //   link: "/customers",
  //   icon: Icons.SIDE_BAR_CUSTOMERS,
  // },
  // {
  //   key: "services",
  //   label: "services",
  //   link: "/services",
  //   icon: Icons.SIDE_BAR_SERVICES,
  // },
  {
    key: "staff",
    label: "Staff",
    link: "/staff",
    icon: Icons.SIDE_BAR_STAFF,
  },
  {
    key: "earnings",
    label: "earnings",
    link: "/earnings",
    icon: Icons.SIDE_BAR_EARNINGS,
  },
  {
    key: "profile",
    label: "Profile",
    link: "/profile",
    icon: Icons.SIDE_BAR_PROFILE,
  },
];
